import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import dayjs from "dayjs";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';

@Component({
    selector: 'app-n-tester-pin',
    templateUrl: './n-tester-pin.component.html',
    styleUrls: ['./n-tester-pin.component.css'],
    standalone: false
})
export class NTesterPinComponent {

  currentPin = null;
  dateStringFormatting = 'YYYY-MM-DD' + '  ' + 'hh:mm:ss'; 
  placeholder: string = "-";

   protected readonly dayjs = dayjs;

  pinObj = {
    pinTypeId: this.data.pinTypeId,
    date: this.data?.date,
    lat: this.data?.lat,
    lng: this.data?.lng,
    farm: this.data?.farm,
    field: this.data?.field,
    fieldId: this.data?.fieldId,
    creatingUser: this.data?.creatingUser,
    pinId:  this.data?.pinId,
    pinDescription: this.data?.pinDescription,
    variety: this.data?.variety,
    crop: this.data?.crop,
    cultivar: this.data?.cultivar,
    growthStage: this.data?.growthStage,
    totalNitrogen: this.data?.totalNitrogen,
    medianValue: this.data?.medianValue,
    averageValue: this.data?.averageValue,
    yieldTarget: this.data?.yieldTarget,
    alreadyApplied: this?.data.alreadyApplied,
    proteinTarget: this.data?.proteinTarget,
    nRecommendation: this.data?.nRecommendation
  }

 
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
     public closePinDialog: MatDialogRef<NTesterPinComponent>,
      public nav: NavBarComponent
  ) { 

  }

  ngOnInit(): void {
    this.nav.toggleLoading(false);
  }

  close(): void {
    this.closePinDialog.close();
  
  }
}
